// extracted by mini-css-extract-plugin
module.exports = {"card":"AccountDetail_card__1iH3H"};